import { animate } from 'motion'
import Component from '../app/component'
import mediaquery from '../helpers/media-queries'

export default class Accordionomponent extends Component {
  constructor (el) {
    super(el)
    this.data = {
      index: -1,
      interactions: true
    }
  }

  init () {
    this.refs.items.forEach(el => {
      const topSelector = el.querySelector(el.dataset.topSelector)
      if (topSelector) {
        topSelector.addEventListener('pointerdown', () => {
          if (!this.data.interactions) {
            return
          }
          const index = this.refs.items.indexOf(el)
          if (index !== this.data.index) {
            this.data.index = this.refs.items.indexOf(el)
          }
          else {
            this.data.index = -1
          }
        })
      }
    })
  }

  watchIndex(value) {
    this.refs.items.forEach((el, i) => {
      const contentEl = el.querySelector(el.dataset.contentSelector)
      if (i === value) {
        el.classList.add(el.dataset.activeClass)          
        if (contentEl) {
          contentEl.style.height = 'auto'
          const height = contentEl.offsetHeight
          const rem = mediaquery.test('small') ? '3rem' : '1.302083rem'
          contentEl.style.height = null
          this.data.interactions = false
          this.animation = animate(
            contentEl,
            {
              height: [null, `calc(${height}px + ${rem})`]
            },
            {
              duration: 1,
              easing: 'cubic-bezier(.92,.11,.14,.92)'
            }
          )
          this.animation.finished.then(() => {
            this.data.interactions = true
          })
        }
      }
      else if (el.classList.contains(el.dataset.activeClass)) {
        if (contentEl) {
          this.data.interactions = false
          this.animation = animate(
            contentEl,
            {
              height: [null, 0]
            },
            {
              duration: 1,
              easing: 'cubic-bezier(.39,.76,.12,1)'
            }
          )

          this.animation.finished.then(() => {
            el.classList.remove(el.dataset.activeClass)
            this.data.interactions = true
          })
        }
      }
    })
  }
}
